var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"placement":"top","content":"回到顶部"}},[_c('back-to-top',{attrs:{"visibility-height":300,"back-position":0,"transition-name":"fade"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }